module.exports = __webpack_public_path__ + "img/03-2-2实施方案.75f82caa.svg";